import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate} from "react-router-dom";
import DataPaymentTable from "../../components/Data-payment-table/dataPaymentTable";
import { Button } from "antd";
import NewMiniDrawer from "../../components/navMenu/menu-nav";

require('firebase/auth')

function PaymentList(){

    let userLogado = useSelector(state => state.usuarioLogado);

    const [cleanFilters, setCleanFilters] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);

    useEffect(() => {

        if (userLogado > 0) {
            return;
        }
        else {
            <Navigate to='/login' />
        }
    }, []);

    return(
        <>
            { 
                useSelector(state => state.usuarioLogado) > 0 ? 
                    <NewMiniDrawer divOpen={
                        <div className="freight-content">
                            <div className="container mb-3">
                                <div className="row">
                                    <div className="col-5">
                                        <h4>Pagamentos</h4>
                                    </div>
                                    <div className="col-4">
                                    </div>
                                    <div className="col-1">
                                        <Button
                                        type="primary"
                                        onClick={() => setCleanFilters(!cleanFilters)}
                                        className="btn-limpar-filtros"
                                        >
                                            Limpar Filtros
                                        </Button>
                                    </div>
                                    <div 
                                        style={{ marginLeft: "1.5%" }} 
                                        className="col-1"
                                        onClick={() => setOpenFilters(!openFilters)}
                                    >
                                        <Button >
                                            Filtros Salvos
                                        </Button>
                                    </div>
                                </div>        
                            </div>
                            <div>
                                <div style={{ height: 400, width: '100%' }}>
                                    <DataPaymentTable cleanFilter={cleanFilters} openFilter={openFilters} onCleanFilterHandled={() => setCleanFilters(false)} onOpenFilterHandled={() => setOpenFilters(false)} />
                                </div>
                            </div>

                            
                        </div>
                }/>
                : 
                <Navigate to='/login' />
            }
        </>
    );
}

export default PaymentList;